import Carousel from "react-multi-carousel"
import { VideoThumbnail } from "./VideoThumbnail"
import useWindowDimensions from "../services/useWindowDimensions"
import { VideoType } from "../services/api/video"
import { DirectType } from "../services/api/direct"
import { DirectPoster } from "./DirectPoster"
// @ts-ignore CSS files are loaded by the bundler and have no TypeScript declarations.
import "react-multi-carousel/lib/styles.css"
import { Box } from "@mui/material"

const responsive = {
  desktop: {
    breakpoint: { max: 30000, min: 1024 },
    items: 6,
  },
  tablet: {
    breakpoint: { max: 1024, min: 512 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 512, min: 0 },
    items: 1,
  },
}

export const VideoCarousel = ({ videos }: { videos: VideoType[] }) => {
  const { width } = useWindowDimensions()
  return (
    <Carousel
      responsive={responsive}
      showDots
      autoPlay={width >= 1200}
      infinite
      pauseOnHover
      draggable={false}
      swipeable={false}
      arrows={false}
    >
      {videos.map((video) => (
        <Box key={video.id} sx={{ m: 1, pb: 2 }}>
          <VideoThumbnail video={video} />
        </Box>
      ))}
    </Carousel>
  )
}

export const DirectCarousel = ({ directs }: { directs: DirectType[] }) => {
  const { width } = useWindowDimensions()
  return (
    <Carousel
      responsive={responsive}
      showDots
      autoPlay={width >= 1200}
      infinite
      pauseOnHover
      draggable={false}
      swipeable={false}
      arrows={false}
    >
      {directs.map((direct) => (
        <Box key={direct.id} sx={{ m: 1, pb: 2 }}>
          <DirectPoster direct={direct} />
        </Box>
      ))}
    </Carousel>
  )
}
